export var EnumFileStatus;
(function (EnumFileStatus) {
    EnumFileStatus["INPROCESS"] = "inprocess";
    EnumFileStatus["COMPLETED"] = "completed";
    EnumFileStatus["ERROR"] = "failed";
    EnumFileStatus["FAILED"] = "failed";
    EnumFileStatus["SUCCESS"] = "completed";
})(EnumFileStatus || (EnumFileStatus = {}));
export var casUploadHistoryTableColumn = [
    {
        columnName: "Uploaded On",
        key: "createddate",
        type: "string",
        applySorting: true,
        arrows: true,
    },
    {
        columnName: "Client Name",
        key: "clientname",
        type: "string",
        applySorting: true,
        arrows: true,
    },
    {
        columnName: "Account Code",
        key: "clientcode",
        //client code
    },
    {
        columnName: "Document Name",
        key: "filename",
    },
    // {
    //   columnName: "Source",
    //   key: "source",
    // },
    {
        columnName: "Status",
        key: "filestatus",
        type: "string",
        applySorting: true,
        arrows: true,
    },
    {
        columnName: "Pan No.",
        key: "panno",
        type: "string",
        applySorting: true,
        arrows: true,
    },
    {
        columnName: "Action",
        key: "id",
    },
];
